import './App.css';
import Nav from './components/Nav/Nav';
import Store from './components/Store/Store';


function App() {
  return (
    <div className="App">
      <Nav></Nav>
      <Store></Store>
    </div>
  );
}

export default App;
